export default __webpack_public_path__ + "static/media/pc.06abddd0.png";